export const aftcabinImageOptions = {
  angle: 'aftcabin',
  staticOptions: {
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    BeautyBox: 1,
    PouffeFabric: 1,
    PouffeBase: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    Backrest: 1,
    TableBox: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49MK2/views/aftcabin.js